import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CreateOrUpdateJobRequest, HttpResponse, Job } from "@/types";

// TODO: See if there is a better way to do this...

export function useUpdateTargetJob() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      request,
      targetJobId,
    }: {
      request: CreateOrUpdateJobRequest;
      targetJobId: string;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${targetJobId}`;
      const res = await httpClient.patch<
        Job,
        HttpResponse<Job>,
        CreateOrUpdateJobRequest
      >(path, request);

      return res.data;
    },
  });

  return mutation;
}
